<template>
  <div class="input-numeric-range__container">
    <PrmInputNumber
      :model-value="props.modelValue.min"
      :disabled="disabled"
      :min="min"
      :max="max"
      :step="step"
      :max-fraction-digits="maxFractionDigits"
      class="input-numeric-range__input"
      @update:model-value="onChange('min', $event)"
    />
    <QmulusSlider
      :model-value="[
        props.modelValue.min,
        props.modelValue.max,
      ]"
      :disabled="disabled"
      range
      :min="min"
      :max="max"
      :step="step"
      class="input-numeric-range__slider"
      @update:model-value="onSliderChange($event as number[])"
    />
    <PrmInputNumber
      :model-value="props.modelValue.max"
      :disabled="disabled"
      :min="min"
      :max="max"
      :step="step"
      :max-fraction-digits="maxFractionDigits"
      class="input-numeric-range__input"
      @update:model-value="onChange('max', $event)"
    />
  </div>
</template>

<script setup lang="ts">
import PrmInputNumber from '@NitrexGroup/primevue/inputnumber';

import QmulusSlider from '../slider/qmulus-slider.vue';

import {
  TNumericRange,
} from './input-numeric-range.ts';

export interface INumericRangeProps {
  modelValue: TNumericRange,
  disabled?: boolean,
  maxFractionDigits?: number,
  min?: number,
  max?: number,
  step?: number,
}

const props = defineProps<INumericRangeProps>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: TNumericRange): void,
}>();

function onChange(which: 'min' | 'max', value: number) {
  const newRange = {
    ...props.modelValue,
  };
  newRange[which] = value;

  emit('update:modelValue', newRange);
}

function onSliderChange(sliderValue: number[]) {
  emit('update:modelValue', {
    min: Math.min(...sliderValue),
    max: Math.max(...sliderValue),
  });
}
</script>

<style scoped lang="scss">
.input-numeric-range {
  &__container {
    display: flex;
    gap: var(--gap-union);
    align-items: center;
  }

  &__slider {
    margin: 0 1.143rem; // $sliderHandleHeight of PrimeVue LaraTheme
    width: 10rem;
  }

  &__input {
    :deep(input) {
      width: 5rem;
    }
  }
}
</style>
